import { render, staticRenderFns } from "./DocDisplay.vue?vue&type=template&id=29c0c26b&"
import script from "./DocDisplay.vue?vue&type=script&lang=js&"
export * from "./DocDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports